import React, { useEffect, useRef } from 'react'
import StyledDiv from './styles'

export const PERSISTENT_MAP_HOST_ID = 'persistent-map-host'
export const PERSISTENT_MAP_MOUNT_ID = 'persistent-map-mount'

const MapSlot: React.FC = () => {
  const slotRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const slot = slotRef.current
    const mount = document.getElementById(PERSISTENT_MAP_MOUNT_ID)
    if (!slot || !mount) return

    slot.appendChild(mount)

    const callRefresh = () => {
      const fn = (window as any).__refreshPersistentMap as (() => void) | undefined
      fn?.()
    }

    callRefresh()
    requestAnimationFrame(callRefresh)

    let raf = 0
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(callRefresh)
    })
    observer.observe(slot)

    return () => {
      observer.disconnect()
      cancelAnimationFrame(raf)
      const host = document.getElementById(PERSISTENT_MAP_HOST_ID)
      if (host && mount.parentNode !== host) host.appendChild(mount)
    }
  }, [])

  return <StyledDiv ref={slotRef} className='map-slot' />
}

export default MapSlot
